module.exports = __webpack_public_path__ + "static/media/David_K.7117be04.jpg";